// 会员关系路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/membership',
  component: Layout,
  children: [
    {
      path: 'membershipList',
      component: () => import('@/view/membership/membershipList'),
      name: '社群'
    },
    {
      path: 'membershipImpower',
      component: () => import('@/view/membership/membershipImpower'),
      name: '社群授权设置'
    },
    {
      path: 'membershipSop',
      component: () => import('@/view/membership/membershipSop'),
      name: '群sop'
    },
    {
      path: 'membershipSop/:id',
      component: () => import('@/view/membership/membershipSopEdit'),
      name: '群sop详情'
    },
    {
      path: 'membershipSopAdd',
      component: () => import('@/view/membership/membershipSopAdd'),
      name: '群sop规则设置'
    },
    {
      path: 'membershipSopAdd/:id',
      component: () => import('@/view/membership/membershipSopAdd'),
      name: '群sop规则编辑'
    },
    {
      path: 'membershipBind',
      component: () => import('@/view/membership/membershipBind'),
      name: '会员关系设置'
    },
    {
      path: 'membershipWelcome',
      component: () => import('@/view/membership/membershipWelcome'),
      name: '群欢迎语'
    },
    {
      path: 'membershipWelcome/:id',
      component: () => import('@/view/membership/membershipWelcomeEdit'),
      name: '群欢迎语编辑'
    },
    {
      path: 'intoGroupRelations',
      component: () => import('@/view/membership/intoGroupRelations'),
      name: '入群关系绑定表'
    },
    {
      path: 'customerGroup',
      component: () => import('@/view/membership/customerGroup'),
      name: '客户群发'
    },
    {
      path: 'customerGroup/:id',
      component: () => import('@/view/membership/customerGroupDetail'),
      name: '客户群发编辑页'
    },
    {
      path: 'customerGroupInfo/:id',
      component: () => import('@/view/membership/customerGroupInfo'),
      name: '客户群发详情页'
    }
  ]
}
